import {FC, useEffect} from 'react';
import Page from "components/Page";
import {Box, Stack} from "@mui/material";
import {Filters} from "./Main/Filters";
import PageContent from "components/PageContext";
import {Outlet} from "react-router-dom";
import PageTitle from 'components/PageTitle';
import {List} from "./Main/List";
import {
    EquipmentRelocationRequestEntity,
    GetRelocationRequestsInput,
    useGetRelocationRequestsLazyQuery
} from "graphql/graphQlApiHooks";
import {equipmentRelocationRequestsFiltersVar, useEquipmentRelocationRequestsFilters} from 'store/reactiveVarsStores/equipment-relocate/filtersVar';
import {useReactiveVar} from "@apollo/client";
import {
    equipmentRelocationRequestListSortOrderVar
} from "store/reactiveVarsStores/equipment-relocate/equipmentRelocatedListSortOrder";
import {
    equipmentRelocationRequestListPaginationVar
} from "store/reactiveVarsStores/equipment-relocate/equipmentRelocatedListPagination";
import {EquipmentRelocationRequestStatusEnum} from "store/stores/equipment-relocation-request-status.enum";
import {sportObjectsVars} from "../../../store/reactiveVarsStores/sport-objects/sportObjects";
import SearchByName from "../Equipments/components/Main/Header/SearchByName/SearchByName";


export const EquipmentRelocate: FC = () => {
    const pageTitle = "Свободное оборудование и инвентарь";
    const filterValues = useReactiveVar(equipmentRelocationRequestsFiltersVar);
    const pagination = useReactiveVar(equipmentRelocationRequestListPaginationVar);
    const equipmentRequestListSortOrder = useReactiveVar(equipmentRelocationRequestListSortOrderVar);
    const sportObjects = useReactiveVar(sportObjectsVars);
    const {setFilters} = useEquipmentRelocationRequestsFilters();

    const [getRelocationRequests, {data, loading, error}] = useGetRelocationRequestsLazyQuery({
        pollInterval: 3000
    });

    useEffect(() => {
            const {createdAt, statuses, sourceSportObjectIds, targetSportObjectIds, searchText, ...filters} = filterValues;

            if (sportObjects.sportObjectList.length === 0) {
                return;
            }

            if (!sourceSportObjectIds) {
                equipmentRelocationRequestsFiltersVar({
                    ...filterValues,
                    sourceSportObjectIds: sportObjects.sportObjectList.map((sportObject) => sportObject.id),
                });

                return;
            }

            getRelocationRequests({
                variables: {
                    input: {
                        ...filters,

                        ...(searchText && { searchText }),

                        ...createdAt && {
                            dateFrom: createdAt?.startDate.toISOString(),
                            dateTo: createdAt?.endDate.toISOString()
                        },

                        sourceSportObjectIds: sourceSportObjectIds,
                        targetSportObjectIds: targetSportObjectIds,

                        statuses: statuses?.map((status) => EquipmentRelocationRequestStatusEnum[status]),


                        skip: pagination.page * pagination.pageSize,
                        take: pagination.pageSize,
                        order: equipmentRequestListSortOrder
                    } as GetRelocationRequestsInput
                }
            });

        }, [pagination, equipmentRequestListSortOrder, filterValues, sportObjects]
    );


    return (
        <Page title={pageTitle}>
            <Box
                display={"flex"}
                px={5}
                pt={4}
                pb={3}
                justifyContent={"space-between"}
                component={"header"}
                className="page__header"
            >
                <PageTitle title={pageTitle} count={data?.getRelocationRequests?.allCount}/>

                <Box flexGrow={1} />
                <Stack direction={"row"} spacing={3} alignItems={"center"}>
                    <SearchByName
                        placeholder={"Название оборудования"}
                        searchText={filterValues.searchText}
                        searchSportEquipmentByName={(text: string) => {
                            setFilters({ ...filterValues, searchText: text.length > 0 ? text : null });
                        }}
                    />
                </Stack>
            </Box>
            <Filters/>

            <PageContent>
                <List
                    data={data?.getRelocationRequests?.relocationRequests as EquipmentRelocationRequestEntity[]}
                    allCount={data?.getRelocationRequests?.allCount}
                    loading={loading}
                    error={error}
                />
                {<Outlet/>}
            </PageContent>
        </Page>
    );
}
